module.exports = __webpack_public_path__ + "img/tanlinbao.7f58aac1.png";